import { twMerge } from 'tailwind-merge';

const Layout = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={twMerge(
        'h-full w-full overflow-y-auto px-5 py-4 md:h-[initial] lg:py-12 lg:pb-6',
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Layout;
